/// <reference path="../app.ts" />
namespace Cfnc {
    interface IRequestTranscriptScope extends ng.IScope {
        vm: RequestTranscript;
    }

    interface IRequestTranscript {
        user: any;
        participatingApplications: Array<IParticipatingApplication>;
        limitSchools: number;
        importantMessagesExist: boolean;
        requestStarted: boolean;
        requestSent: boolean;
        checkedCount: number;
        schoolChanged: boolean;
        schoolIsValid: boolean;
        saveUserAlerts: Array<any>;
        sendTranscriptResults: Array<ISendTranscriptResult>;
    }

    class UserProfile implements IUserProfile {
        addressVerified: boolean;
        associatedSchools: Array<ICustomerViewModel>;
        comments: Array<any>;
        customer: ICustomerViewModel;
        dateOfBirth: string;
        daytimePhone: string;
        email: string;
        enrollmentStatus: number;
        eveningPhone: string;
        firstName: string;
        fromServer: boolean;
        gender: number;
        graduationYear: number;
        id: number;
        lastName: string;
        mailAddress: IAddress;
        mailingPhone: string;
        middleName: string;
        nickname: string;
        permAddress: IAddress;
        phoneNumber: string;
        primaryConnectionCrmId: number;
        role: number;
        socialSecurityNumber: string;
        studentId: string;
        suffix: string;
        userContactInfo: any;
        username: string;
        mobilePhone: string;
        homePhone: string;
        workPhone: string;
        emailInvalid: boolean;
        addressInvalid: boolean;
        phoneNumberInvalid: boolean;
        passwordInvalid: boolean;
        textingOptIns: ITextingOptIns;
        emailIsValid?: boolean;
        emailVerified?: boolean;
        emailSignature: string;
        tin: string;
    }

    interface ISendTranscriptResult {
        applicationId: string;
        status: string;
        message: string;
    }

    interface IParticipatingApplication {
        applicationId: string;
        ceeb: string;
        name: string;
        sendTranscriptResult: ISendTranscriptResult;
        checked: boolean;
    }

    class RequestTranscript implements IRequestTranscript {
        static controllerId: string = "requestTranscript";
        static $inject: Array<string> = ["$scope", "$uibModal", "common", "$timeout", "transcriptDataService", "Restangular", "config"];
        private log;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        user: any;
        participatingApplications: Array<IParticipatingApplication> = [];
        limitSchools: number = 15;
        importantMessagesExist: boolean;
        requestStarted: boolean = false
        requestSent: boolean = false;
        requestSuccess: boolean = false;
        checkedCount: number = 0;
        schoolChanged: boolean = false;
        schoolIsValid: boolean = true;
        saveUserAlerts: Array<any> = [];
        maxDate = new Date();
        gender: string;
        originalEmail: string;
        sendTranscriptResults: Array<ISendTranscriptResult>;
        savingUserProfile: boolean = false;
        transcriptRequestNotification: any;

        constructor(private $scope: IRequestTranscriptScope,
            private $uibModal: ng.ui.bootstrap.IModalService,
            private common: ICommonFactory,
            private $timeout: ng.ITimeoutService,
            private transcriptDataService: ITranscriptDataService,
            private Restangular: Restangular.IService,
            private config: IConfig) {

            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    this.log = common.logger.getLogFn(RequestTranscript.controllerId);
                    this.logSuccess = common.logger.getLogFn(RequestTranscript.controllerId, "success");
                    this.logError = common.logger.getLogFn(RequestTranscript.controllerId, "error");
                    this.activate();


                    transcriptDataService.getParticipatingApplications().then((data) => {
                        var appid = sessionStorage.getItem("transcriptRequest.appid");
                        this.participatingApplications = data;

                        var selectedApp = _.find(this.participatingApplications, (p) => {
                            return p.applicationId == appid;
                        });

                        if (selectedApp) {
                            selectedApp.checked = true;
                        }

                        sessionStorage.removeItem("transcriptRequest.appid");
                    });

                    this.importantMessagesExist = false;

                    if (this.importantMessagesExist) {
                        var modalInstance = this.$uibModal.open({
                            templateUrl: '/app/apphub/importantMessageModal.html',
                            controller: 'importantMessageModal',
                        });
                    }
                }
            });

            $scope.$on(config.events.logout, (event) => {
                this.common.authentication.authenticate(true);
            });
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, RequestTranscript.controllerId)
                .then(() => {
                    this.getTranscriptRequestNotification();
                    this.log("Activated StartNewApp View");
                });

            this.Restangular.one("users/profile").get()
                .then((result) => {
                    if (result) {
                        this.user = result;
                        this.gender = this.user.gender.toString();
                        if (this.user.customer) {
                            this.isSchoolValid(this.user.customer.ceeb_code);
                        }
                        else {
                            this.schoolIsValid = false;
                            this.user.customer = { name: "My School or Program is not listed"}
                        }
                        this.originalEmail = this.user.email;
                    }
                }, (reason) => {
                    this.logError(reason);
                });



        }


        request() {
            var cnt = 1;
            this.requestStarted = true;
            var selectedApplications = _.map(_.filter(this.participatingApplications, function (a) { return a.checked; }), "applicationId");
            var transcriptRequest: TranscriptRequest = { ceeb: this.user.customer.ceeb_code, userId: this.user.id, applicationIds: selectedApplications };

            this.transcriptDataService.requestTranscript(transcriptRequest).then((response: Array<ISendTranscriptResult>) => {
                this.requestSent = true;
                this.requestStarted = false;
                this.requestSuccess = true;
                this.sendTranscriptResults = response;

                response.forEach((result) => {
                    _.find(this.participatingApplications, { applicationId: result.applicationId }).sendTranscriptResult = result;
                });
            },
                (reason) => {
                    this.requestSuccess = false;
                    this.requestStarted = false;
                });
        }

        reset() {
            this.participatingApplications.forEach((school) => {
                school.checked = false;
                school.sendTranscriptResult = null;
            });
            this.requestSent = false;
            this.requestStarted = false;
            this.requestSuccess = false;
            this.checkedCount = 0;
        }

        isRequestSuccessful(applicationId: string): boolean {
            var result = _.find(this.sendTranscriptResults, { applicationId: applicationId });

            return result.status == "Success";
        }

        getRequestMessage(applicationId: string): string {
            var result = _.find(this.sendTranscriptResults, { applicationId: applicationId });
            return result.message;
        }

        saveUserProfile(form: ng.IFormController) {
            this.savingUserProfile = true;
            this.user.addressVerified = true;
            this.user.gender = parseInt(this.gender);
            this.user.permAddress = null;
            this.user.mailAddress = null;

            this.Restangular.all("users/profile/save").customPUT(this.user)
                .then((result) => {
                    form.$setPristine();
                    this.schoolChanged = false;
                    this.log("User Updated");
                    //this.common.authentication.refreshToken(true).then((result) => {
                    //    this.log("Token Refreshed", result, false);
                    //}, (reason) => {
                    //    this.log("Error Refreshing token", reason, false);
                    //});
                    this.saveUserAlerts.push({ type: "success", msg: "User information saved successfully." });
                    this.savingUserProfile = false;
                }, (reason) => {
                    this.logError("An error occurred saving the user profile", reason, false);
                    if (reason.status == 400 && reason.data.modelState && reason.data.modelState.exception) {
                        var message = "An error occurred while saving your information.";
                        reason.data.modelState.exception.forEach((exception) => {
                            message = message + " " + exception;
                        });
                        this.saveUserAlerts.push({ type: "danger", msg: message });
                    }
                    else {
                        this.saveUserAlerts.push({ type: "danger", msg: "An error occurred while saving your information. Please try again later." });
                    }   
                    this.savingUserProfile = false;
                });
        }

        openTranscriptMessage() {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/apphub/transcriptmessagemodal.html',
                controller: 'transcriptMessageModal',
                size: 'lg'
            });
        }

        checkChanged(checked) {
            if (checked) {
                this.checkedCount += 1;
            }
            else {
                this.checkedCount -= 1;
            }
        }

        change = (selectedSchool) => {
            if (selectedSchool.ceeb_code != null) {
                this.isSchoolValid(selectedSchool.ceeb_code);
            }
            else {
                this.schoolIsValid = false;
            }
            this.user.primaryConnectionCrmId = selectedSchool.crmId
            this.schoolChanged = true;
        };

        isSchoolValid = (ceeb: number) => {
            this.Restangular.one("highschools/isparticipatinghighschool", ceeb).get().then((results) => {
                this.schoolIsValid = results;

            }, (reason) => {
                this.logError("An error occurred validating the selected school", reason, false);
                this.schoolIsValid = false;
            });

        };


        closeAlert = (index: number) => {
            this.saveUserAlerts.splice(index, 1);
        }

        getTranscriptRequestNotification(): angular.IPromise<any> {
            return this.Restangular.withConfig(config => {
                config.setBaseUrl(this.config.umbracoUrl);
            }).one("api/sitenotifications").get({ targets: "transcript request" })
                .then(result => {
                    if (result && result.message) {
                        this.transcriptRequestNotification = result;
                    }
                }, error => {
                    this.logError("An error occurred getting the site notifications.", error, false);
                });
        }

    }

    angular.module("app").controller(RequestTranscript.controllerId, RequestTranscript);

}